import { IntegerValue } from '../abstract/integer-value';
import { PreferNominal } from '../abstract/prefer-nominal';
import { UrlValue } from '../abstract/url-value';

export class TermsOfServiceUrl extends UrlValue {
  url!: PreferNominal;

  constructor(value: string) {
    super(value);
  }
}
